module.exports = __webpack_public_path__ + "static/Tile3-Normal-footage-1f433ad4d397bb2b2fbcdcf6ff7785d3.gif";